import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Add from "../pages/compare/Add";
import Compare from "../pages/compare/Compare";

class ComparePortfolio extends Component {
  components = [Add, Compare];

  state = {
    isLoaded: false,
    steps: [
      {
        title: "Enter Portfolio Weights",
        full_title: "Enter Your portfolio weights",
      },
      {
        title: "Portfolio Comparision",
        full_title: "Portfolio Comparision",
      },
    ],
    step: 0,
    step_rules: {},
    dataFromChild: 0,
    items: [],
  };

  // call back function used to get child data ie.onClick scenario_number
  myCallBack = (dataFromChild) => {
    this.setState({
      dataFromChild,
    });
  };

  setStep(step) {
    this.setState({ step });
  }
  componentWillMount() {
    this.props.setPath(["Compare Portfolio"]);

    //resetting direct review portfolio
    this.props.resetDirectReviewPortfolio();
    this.props.resetCurrentActiveStep(0);
  }

  //setting step to zero if clicked on navigation
  componentWillReceiveProps(newProps) {
    if (this.state.step !== 0 && newProps.activeStep !== null) {
      this.setState({
        step: newProps.activeStep,
      });
    }
  }

  // nav to next step
  nav = () => {
    let { step, steps } = this.state;

    if (steps.length > +step + 1) {
      this.setState({ step: ++step });
    }
  };
  navBackStep = () => {
    let { step, steps } = this.state;

    if (this.state.step > 0) {
      this.setState({ step: --step });
      console.log("clicked call back function");
    }
  };
  updateItems = (items) => {
    this.setState({ items });
  };
  render() {
    const { step, steps } = this.state;
    const CurrentStep = (() => this.components[step])();
    return (
      <Fragment>
        <div className="page-content">
          <div className="head-section">
            <h1 className="text-uppercase">
              Compare Portfolios
              <sup>
                <small>
                  {" "}
                  <b>BETA</b>{" "}
                </small>
              </sup>
            </h1>
            <ul className="steps">
              {steps.map((v, i) => (
                <li key={i} className={this.state.step == i ? "active" : null}>
                  {/* <a
                    href={"#"}
                    data-toggle="tab"
                    className="steps__step"
                    onClick={() => this.setStep(i)}
                  > */}
                  {/* uncomment above anchor tag and comment below anchor tag to toggle between two component in header section */}
                  <a className="steps__step ">
                    <span className="steps__step-number">
                      <span>{i + 1}</span>
                    </span>
                    <span className="steps__step-desc">{steps[i].title}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="page-body">
            <div className="step clearfix">
              <div className="step__title text-uppercase">
                {steps[step].full_title}
              </div>
              <CurrentStep
                callbackFromParent={this.myCallBack}
                {...this.state}
                navToNextPage={this.nav}
                navToBackStep={this.navBackStep}
                updateItems={this.updateItems}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default connect(
  ({ layout: { activeStep } }) => ({
    activeStep,
  }),
  (dispatch) => ({
    resetDirectReviewPortfolio: () =>
      dispatch({
        type: "RESET_DIRECT_REVIEW_PORTFOLIO_OPTIMIZE_DATA",
      }),
    resetCurrentActiveStep: (value) =>
      dispatch({ type: "SET_ACTIVE_STEP_COUNT", payload: value }),
  })
)(ComparePortfolio);



// WEBPACK FOOTER //
// ./src/components/pages/ComparePortfolio.jsx